import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';
// layout
import { LayoutDefaultComponent } from '../layout/default/default.component';
import { LayoutPassportComponent } from '../layout/passport/passport.component';
// dashboard pages
import { DashboardComponent } from './dashboard/dashboard.component';
// passport pages
import { UserLoginComponent } from './passport/login/login.component';
import { UserRegisterComponent } from './passport/register/register.component';
import { UserRegisterResultComponent } from './passport/register-result/register-result.component';
// single pages
import { CallbackComponent } from './callback/callback.component';
import { UserLockComponent } from './passport/lock/lock.component';
import { Exception403Component } from './exception/403.component';
import { Exception404Component } from './exception/404.component';
import { Exception500Component } from './exception/500.component';
import { LicenseGrantComponent } from './license-grant/license-grant.component';
import { LicenseComponent } from './passport/license/license.component';

import { LockGuard } from '@core/guard/lockGuard';
import { ProcessViewComponent } from './workflow/process-view/process-view.component';
import { ResetPasswordComponent } from './passport/reset-password/reset-password.component';
import { SendEmailSuccessComponent } from './passport/send-email-success/send-email-success.component';
import { ResetPasswordPageComponent } from './passport/reset-password-page/reset-password-page.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutDefaultComponent,
    canActivate: [LockGuard],
    children: [
      { path: '', redirectTo: '/supplier-portal/home-page', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { title: '仪表盘', titleI18n: 'dashboard.title.dashboard' },
      },
      { path: 'licenseGrant', component: LicenseGrantComponent, data: { title: '系统授权' } },
      // 基础平台功能模块
      { path: 'commons', loadChildren: './jy-commons/jy-commons.module#JyCommonsModule' },
      { path: 'authorization', loadChildren: './jy-authorization/jy-authorization.module#JyAuthorizationModule' },
      { path: 'dev-tools', loadChildren: './dev-tools/dev-tools.module#DevToolsModule' },
      { path: 'extend-field', loadChildren: './jy-extend-field/jy-extend-field.module#JyExtendFieldModule' },
      { path: 'dict', loadChildren: './jy-dict/dict.module#DictModule' },
      { path: 'content', loadChildren: './jy-content/jy-content.module#JyContentModule' },
      { path: 'org', loadChildren: './jy-org/jy-org.module#JyOrgModule' },
      { path: 'log', loadChildren: './jy-log/jy-log.module#JyLogModule' },
      { path: 'sip', loadChildren: './jy-sip/jy-sip.module#JySipModule' },
      { path: 'workflow', loadChildren: './workflow/workflow.module#WorkflowModule' },
      { path: 'msg-management', loadChildren: './jy-msg-management/jy-msg-management.module#JyMsgManagementModule' },
      { path: 'system-msg', loadChildren: './jy-message/jy-message.module#JyMessageModule' },
      //业务功能模块
      { path: 'demo', loadChildren: './jy-demo/jy-demo.module#JyDemoModule' },
      //srm模块
      { path: 'region', loadChildren: './jy-srm/basic-data/srm-region/srm-region.module#SrmRegionModule' },
      { path: 'sup', loadChildren: './jy-srm/basic-data/srm-sup/srm-sup.module#SrmSupModule' },
      { path: 'tax', loadChildren: './jy-srm/basic-data/srm-tax/srm-tax.module#SrmTaxModule' },
      { path: 'address', loadChildren: './jy-srm/basic-data/srm-address/srm-address.module#SrmAddressModule' },
      { path: 'bank', loadChildren: './jy-srm/basic-data/srm-bank/srm-bank.module#SrmBankModule' },
      {
        path: 'requireGoodsStrategy',
        loadChildren: './jy-srm/basic-data/srm-requireGoodsStrategy/srm-requireGoodsStrategy.module#SrmRequireGoodsStrategyModule',
      },
      {
        path: 'supply-type',
        loadChildren: './jy-srm/basic-data/srm-supply-type/srm-supply-type.module#SrmSupplyTypeModule',
      },
      {
        path: 'profession',
        loadChildren: './jy-srm/basic-data/srm-profession/srm-profession.module#SrmProfessionModule',
      },
      {
        path: 'certificate',
        loadChildren: './jy-srm/basic-data/srm-certificate/srm-certificate.module#SrmCertificateModule',
      },
      { path: 'structure', loadChildren: './jy-srm/basic-data/srm-structure/srm-structure.module#SrmStructureModule' },
      { path: 'config-para', loadChildren: './jy-srm/basic-data/srm-config/srm-config.module#SrmConfigModule' },
      {
        path: 'qual-detail',
        loadChildren: './jy-srm/basic-data/srm-qual-detail/srm-qual-detail.module#SrmQualDetailModule',
      },
      {
        path: 'supplier-config',
        loadChildren: './jy-srm/supplier/supplier-config/supplier-config.module#SupplierConfigModule',
      },

      {
        path: 'supplier-base',
        loadChildren: './jy-srm/supplier/supplier-base/supplier-base.module#SupplierBaseModule',
      },

      {
        path: 'supplier-view',
        loadChildren: './jy-srm/supplier/supplier-view/supplier-view.module#SupplierViewModule',
      },
      {
        path: 'supplier-complaint',
        loadChildren: './jy-srm/supplier/sup-complaint/sup-complaint.module#SupComplaintModule',
      },
      { path: 'mold', loadChildren: './jy-srm/mold/mold.module#MoldModule' },
      {
        path: 'material-info',
        loadChildren: './jy-srm/purchase/material-info/material-info.module#MaterialInfoModule',
      },
      {
        path: 'material-detail',
        loadChildren: './jy-srm/purchase/material-info/material-detail/material-detail.module#MaterialDetailModule',
      },
      { path: 'assets', loadChildren: './jy-srm/contract-order-execute/fixed-assets/assets.module#AssetsModule' },
      { path: 'commodity', loadChildren: './jy-srm/commodity/commodity.module#CommodityModule' },
      {
        path: 'commodity-information',
        loadChildren: './jy-srm/commodity/commodity-information/commodity-information.module#CommodityInformationModule',
      },
      {
        path: 'scene-inspect',
        loadChildren: './jy-srm/supplier/scene-inspect/scene-inspect.module#SceneInspectModule',
      },
      {
        path: 'share-subclass',
        loadChildren: './jy-srm/supplier/share-subclass/share-subclass.module#ShareSubclassModule',
      },
      { path: 'assess', loadChildren: './jy-srm/supplier/supplier-ass/supplier-ass.module#SupplierAssModule' },
      { path: 'ass-order', loadChildren: './jy-srm/supplier/supAss/sup-ass-order.module#SupAssQuailModule' },
      {
        path: 'sample-certification',
        loadChildren: './jy-srm/supplier/sample-certification/sample-certification.module#SampleCertificationModule',
      },
      {
        path: 'sup-change-status',
        loadChildren: './jy-srm/supplier/change-status/sup-change-status.module#SupChangeStatusModule',
      },

      {
        path: 'supplier-new',
        loadChildren: './jy-srm/supplier/supplier-base/supplier-new/supplier-new.module#SupplierNewModule',
      },
      {
        path: 'small-batch',
        loadChildren: './jy-srm/small-batch/small-batch.module#SmallBatchModule',
      },


      { path: 'expert', loadChildren: './jy-srm/expert/srm-expert.module#SrmExpertModule' },
      {
        path: 'supplier-new',
        loadChildren: './jy-srm/supplier/supplier-base/supplier-new/supplier-new.module#SupplierNewModule',
      },
      {
        path: 'sales-opportunity',
        loadChildren: './jy-srm/sales-opportunity/tech-document/tech-document.module#TechDocumentModule',
      },
      {
        path: 'price-repository',
        loadChildren: './jy-srm/sales-opportunity/price-repository/price-repository.module#PriceRepositoryModule',
      },
      {
        path: 'supplier-reform',
        loadChildren: './jy-srm/supplier/supplier-reform/supplier-reform.module#SupplierReformModule',
      },
      { path: 'marking-scheme', loadChildren: './jy-srm/marking-scheme/marking-scheme.module#MarkingSchemeModule' },
      {
        path: 'price-approval',
        loadChildren: './jy-srm/sales-opportunity/price-approval/price-approval.module#PriceApprovalModule',
      },
      { path: 'price', loadChildren: './jy-srm/price-form/srm-price.module#SrmPriceModule' },
      {
        path: 'supplier-reform',
        loadChildren: './jy-srm/supplier/supplier-reform/supplier-reform.module#SupplierReformModule',
      },
      { path: 'marking-scheme', loadChildren: './jy-srm/marking-scheme/marking-scheme.module#MarkingSchemeModule' },
      { path: 'srm-workflow', loadChildren: './jy-srm/srm-workflow/srm-workflow.module#SrmWorkflowModule' },
      {
        path: 'purchase-order',
        loadChildren: './jy-srm/order/purchase-order/purchase-order.module#PurchaseOrderModule',
      },
      { path: 'procurement', loadChildren: './jy-srm/procurement-mall/procurement-mall.module#ProcurementMallModule' },
      {
        path: 'claim-management',
        loadChildren: './jy-srm/contract-order-execute/claim-management/claim-management.module#ClaimManagementModule',
      },
      { path: 'leave-message', loadChildren: './jy-srm/leave-message/srm-leave-message.module#SrmLeaveMessageModule' },
      { path: 'qual-expired', loadChildren: './jy-srm/supplier/supplier-qual/supplier-qual.module#SupplierQualModule' },
      {
        path: 'supplier-invited',
        loadChildren: './jy-srm/supplier/supplier-invite/supplier-invite.module#SupplierInviteModule',
      },
      {
        path: 'supplier-rating',
        loadChildren: './jy-srm/supplier/supplier-rating/supplier-rating.module#SupplierRatingModule',
      },
      {
        path: 'supplier-account',
        loadChildren: './jy-srm/supplier/supplier-account/supplier-account.module#SupplierAccountModule',
      },
      {
        path: 'supplier-modify',
        loadChildren: './jy-srm/supplier/supplier-modify/supplier-modify.module#SupplierModifyModule',
      },
      {
        path: 'supplier-guide',
        loadChildren: './jy-srm/supplier/supplier-guide/supplier-guide.module#SupplierGuideModule',
      },
      {
        path: 'receiving-management',
        loadChildren: './jy-srm/contract-order-execute/receiving-management/receiving-management.module#ReceivingManagementModule',
      },
      {
        path: 'supplier-guide',
        loadChildren: './jy-srm/supplier/supplier-guide/supplier-guide.module#SupplierGuideModule',
      },
      {
        path: 'invoice-strategy',
        loadChildren: './jy-srm/basic-data/srm-invoice-strategy/srm-invoice-strategy.module#SrmInvoiceStrategyModule',
      },
      { path: 'cargo-plan', loadChildren: './jy-srm/cargo-plan/cargo-plan.module#CargoPlanModule' },
      { path: 'asn', loadChildren: './jy-srm/asn/asn.module#AsnModule' },
      {
        path: 'quality-management',
        loadChildren: './jy-srm/contract-order-execute/quality-management/quality-management.module#QualityManagementModule',
      },
      { path: 'soa', loadChildren: './jy-srm/soa/soa.module#SoaModule' },
      { path: 'tender-mat', loadChildren: './jy-srm/tender-mat/tender-mat.module#TenderMatModule' },
      { path: 'technical-standard-circulation', loadChildren: './jy-srm/technical-standard-circulation/technical-standard-circulation.module#TechnicalStandardCirculationModule'},
      { path: 'approve-log', loadChildren: './jy-srm/approve-log/approve-log.module#ApproveLogModule' },
      { path: 'source', loadChildren: './jy-srm/procu-source/source-items/source-items.module#SourceItemsModule' },
      { path: 'chat', loadChildren: './jy-srm/procu-source/chat-info/chat-info.module#ChatInfoModule' },
      {
        path: 'sourcing-workflow',
        loadChildren: './jy-srm/sourcing-workflow/sourcing-workflow.module#SourcingWorkflowModule',
      },
      { path: 'sourcing', loadChildren: './jy-srm/sourcing-config/sourcing-config.module#SourcingConfigModule' },
      {
        path: 'source-sup',
        loadChildren: './jy-srm/procu-source/source-view-sup/source-view-sup.module#SourceViewSupModule',
      },
      {
        path: 'source-pro',
        loadChildren: './jy-srm/procu-source/source-view-pro/source-view-pro.module#SourceViewProModule',
      },
      {
        path: 'sourcing-management',
        loadChildren: './jy-srm/sourcing-management/sourcing-management.module#SourcingManagementModule',
      },
      { path: 'parity', loadChildren: './jy-srm/inquiry-parity/source-items/source-items.module#InquiryItemsModule' },
      {
        path: 'parity-pro',
        loadChildren: './jy-srm/inquiry-parity/source-view-pro/source-view-pro.module#InquiryViewProModule',
      },
      {
        path: 'parity-management',
        loadChildren: './jy-srm/inquiry-parity/sourcing-management/sourcing-management.module#SourcingManagementModule',
      },
      {
        path: 'parity-sup',
        loadChildren: './jy-srm/inquiry-parity/source-view-sup/source-view-sup.module#InquiryViewSupModule',
      },
      {
        path: 'parity-workflow',
        loadChildren: './jy-srm/inquiry-parity/sourcing-workflow/sourcing-workflow.module#InquiryWorkflowModule',
      },
      {
        path: 'priceParity',
        loadChildren: './jy-srm/inquiry-parity/priceParity/price-parity.module#PriceParityModule',
      },
      { path: 'compact', loadChildren: './jy-srm/contract-order-execute/compact/compact.module#CompactModule' },
      { path: 'receipt', loadChildren: './jy-srm/receipt/receipt.module#ReceiptModule' },
      {
        path: 'source-score',
        loadChildren: './jy-srm/procu-source/source-item-score/source-item-score.module#SourceItemScoreModule',
      },
      {
        path: 'stopped-supper',
        loadChildren: './jy-srm/commodity/stopped-supper/stopped-supper.module#StoppedSupperModule',
      },
      { path: 'product-develop', loadChildren: './jy-srm/product-develop/product-develop.module#ProductDevelopModule' },
      {
        path: 'share-allocation',
        loadChildren: './jy-srm/supplier/share-allcation/share-allcation.module#ShareAllcationModule',
      },

      { path: 'start-supply', loadChildren: './jy-srm/commodity/start-supply/start-supply.module#StartSupplyModule' },
      { path: 'pur-requisition', loadChildren: './jy-srm/pur-requisition/pur-requisition.module#PurRequisitionModule' },
      {
        path: 'quoted-price',
        loadChildren: './jy-srm/sales-opportunity/quoted-price/quoted-price.module#QuotedPriceModule',
      },
      {
        path: 'share-exception',
        loadChildren: './jy-srm/supplier/share-exception/share-exception.module#ShareExceptionModule',
      },
      {
        path: 'procurement-mall',
        loadChildren: './jy-srm/procurement-mall/procurement-mall.module#ProcurementMallModule',
      },
      { path: 'stock-plan', loadChildren: './jy-srm/stock-plan/stock-plan.module#StockPlanModule' },
      { path: 'pur-requisition-workflow-person',
        loadChildren: './jy-srm/pur-requisition-workflow-person/pur-requisition-workflow-person.module#PurRequisitionWorkflowPersonModule' },
      { path: 'plant-workflow-person',
        loadChildren: './jy-srm/plant-workflow-person/plant-workflow-person.module#PlantWorkflowPersonModule' },
      { path: 'pur-order-workflow-person',
        loadChildren: './jy-srm/pur-order-workflow-person/pur-order-workflow-person.module#PurOrderWorkflowPersonModule' }
    ],
  },
  // 全屏布局
  // {
  //     path: 'fullscreen',
  //     component: LayoutFullScreenComponent,
  //     children: [
  //     ]
  // },
  // passportpur-order-workflow-person
  {
    path: 'passport',
    component: LayoutPassportComponent,
    // canActivate: [LockGuard],
    children: [
      { path: 'login', component: UserLoginComponent, data: { title: '登录', titleI18n: 'pro-login' } },
      { path: 'register', component: UserRegisterComponent, data: { title: '注册', titleI18n: 'pro-register' } },
      {
        path: 'register-result',
        component: UserRegisterResultComponent,
        data: { title: '注册结果', titleI18n: 'pro-register-result' },
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        data: { title: '重置密码' },
      },
      {
        path: 'send-email-success',
        component: SendEmailSuccessComponent,
        data: { title: '重置密码' },
      },
      {
        path: 'reset-password-page',
        component: ResetPasswordPageComponent,
        data: { title: '重置密码' },
      },
    ],
  },
  // 单页不包裹LayoutF
  { path: 'callback/:type', component: CallbackComponent, canActivate: [LockGuard] },
  { path: 'lock', component: UserLockComponent, data: { title: '锁屏', titleI18n: 'lock' } },
  { path: 'license', component: LicenseComponent, data: { title: '授权', titleI18n: 'license' } },
  {
    path: 'supplier-portal',
    loadChildren: './jy-srm/supplier/supplier-register/supplier-register.module#SupplierRegisterModule',
    data: { title: '供应商注册' },
  },
  { path: '403', component: Exception403Component, canActivate: [LockGuard] },
  { path: '404', component: Exception404Component, canActivate: [LockGuard] },
  { path: '500', component: Exception500Component, canActivate: [LockGuard] },
  {
    path: 'process',
    component: ProcessViewComponent,
    data: { title: '流程查看', titleI18n: 'process' },
    canActivate: [LockGuard],
  },
  //OA打开流程
  { path: 'oa-workflow', loadChildren: './jy-srm/srm-workflow/srm-workflow.module#SrmWorkflowModule' },
  { path: '**', redirectTo: '/supplier-guide/purchase-business' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: environment.useHash })],
  exports: [RouterModule],
  providers: [LockGuard],
})

export class RouteRoutingModule {

}
